import axios from '../requester';
import { LINB_API } from '../constants/api-urls';
import moment from 'moment';

const formatDate = d => moment(d).format('YYYY-MM-DD');

export const RA_API_ERRORS = {
  UNSUPPORTED_SORT_BY: 'Unsupported sort_by value'
};

export const getInvestmentCarving = async ({
  sensor_authorization_id,
  before,
  after
}) => {
  return await axios.post(LINB_API.RESOURCE_ALLOCATION.INVESTMENT_CARVING, {
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after)
  });
};

export const getSummary = async ({
  sensor_authorization_id,
  before,
  after
}) => {
  return await axios.post(LINB_API.RESOURCE_ALLOCATION.WIDGETS.SUMMARY_HEADER, {
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after)
  });
};

export const getOverTimeChart = async ({
  sensor_authorization_id,
  before,
  after,
  type, // project | epic | issue_type | initiative || custom_field
  aggregation_ranges, // month | week
  extraParams,
  filtersPayload,
  limit
}) => {
  return await axios.post(
    LINB_API.RESOURCE_ALLOCATION.WIDGETS.OVER_TIME_CHART,
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      type,
      ...(extraParams && { ...extraParams }),
      aggregation_ranges,
      ...(limit && { limit })
    }
  );
};

export const getDonutChart = async ({
  sensor_authorization_id,
  before,
  after,
  type, // project | epic | issue_type | initiative,
  extraParams,
  filtersPayload,
  limit
}) => {
  return await axios.post(LINB_API.RESOURCE_ALLOCATION.WIDGETS.DONUT_CHART, {
    sensor_authorization_id,
    before: formatDate(before),
    after: formatDate(after),
    type,
    ...(extraParams && { ...extraParams }),
    ...(limit ? { limit } : {})
  });
};

export const getInvestmentCarvingCategoryIssues = async ({
  sensor_authorization_id,
  before,
  after,
  category_key,
  limit,
  offset,
  sort_by,
  sort_dir
}) => {
  return await axios.post(
    LINB_API.RESOURCE_ALLOCATION.INVESTMENT_CARVING_CATEGORY_ISSUES,
    {
      sensor_authorization_id,
      before: formatDate(before),
      after: formatDate(after),
      category_key,
      limit,
      offset,
      ...(sort_by ? { sort_by } : {}),
      ...(sort_dir ? { sort_dir } : {})
    }
  );
};
